/* eslint-disable no-console */
import React from 'react'
import { Input, DatePicker, Row, Col, Card, Typography, Button, Tooltip, Table, Space, Modal, Radio } from 'antd'
import { CalendarOutlined, ReloadOutlined } from '@ant-design/icons'
import moment from 'moment'
import './scrubCopyManager.css'
import Cookie from 'universal-cookie'
import { station } from '../../../../constants/constants'
import { Http } from '../../../../utils'
import ScrubCopy from './scrubCopy'
import ExcelJS from 'exceljs'
import { saveAs } from 'file-saver'
import getScrubData from './getScrubData'
import AppSyncEventManager from '../../../../utils/AppSyncEventManager'

const getComplianceClass = (value) => {
  if (value >= 90) {
    return 'scm-compliance-high'
  }
  if (value >= 80) {
    return 'scm-compliance-mid'
  }
  return 'scm-compliance-low'
}
const { Search } = Input
const cookies = new Cookie()
const { Title } = Typography
class ScrubCopyManager extends React.Component {
  constructor(props) {
    super(props)
    const defaultDate = moment().tz(cookies.get('timezone')).format('YYYY-MM-DD')
    this.state = {
      query: '',
      date: defaultDate,
      flights: [],
      station: cookies.get('station') || station,
      timezone: cookies.get('timezone'),
      modalVisible: false,
      isModalView: false,
      selectedRowKeys: [],
      data: {},
      priorityData: [],
      exportModalVisible: false,
      exportType: 'day',
      exportDate: moment(defaultDate, 'YYYY-MM-DD'),
      exportLoading: false,
    }
    this.eventManager = null
  }

  componentDidMount() {
    this.fetchPriority()
    this.fetchList()
    this.startEvent()
    if (typeof window !== 'undefined') {
      const isModalView = window.innerWidth < 1200
      this.setState({ isModalView })
    }
  }

  componentWillUnmount() {
    if (this.eventManager) {
      this.eventManager.unsubscribe()
    }
  }

  startEvent = () => {
    if (this.eventManager) {
      this.eventManager.unsubscribe()
    }
    this.eventManager = AppSyncEventManager.subscribe('/scrub-copy/' + this.state.station, (data) => {
      let flightData = data?.DETAILS?.data
      if (data?.msg == 'scrub_copy') {
        this.setState((prevState) => {
          const updatedFlights = prevState.flights.map((flight) => {
            if (flight.id === flightData.id) {
              return {
                ...flight,
                scrub_data: flightData.scrub_data
              }
            }
            return flight
          })
          return { flights: updatedFlights }
        })
      }
    })
  }

  fetchPriority = () => {
    Http.get('products_priority?station=DOD').then(({ data }) => {
      if (data?.data?.length > 0) {
        this.setState({ priorityData: data?.data?.[0]?.prod_prior_list || [] })
      }
    })
  }

  fetchList = () => {
    let headers = { station: this.state.station }
    Http.get('/scrub_flight_list', {
      params: { date: this.state.date },
      headers
    })
      .then(({ data }) => {
        this.setState({ flights: data.data })
      })
  }
  formatDecimal = (value) => {
    if (value && value.toString().includes('.')) {
      const decimalPlaces = value.toString().split('.')[1].length
      if (decimalPlaces > 2) {
        return parseFloat(value).toFixed(2)
      }
    }
    return value
  }

  handleSearch = (event) => {
    this.setState({ query: event.target.value })
  }

  handleDateChange = (date) => {
    this.setState({
      date: date ? moment(date).format('YYYY-MM-DD') : null,
      exportDate: date ? moment(date) : null,
    }, () => {
      this.fetchList()
    })
  }

  handleRefresh = () => {
    this.fetchList()
  }

  handleSelectScrubCopy = (record) => {
    if (!record) {
      return
    }
    const selectedRowKey = record.id || record.key
    this.setState({
      selectedRowKeys: selectedRowKey ? [selectedRowKey] : [],
      modalVisible: this.state.isModalView,
      data: record,
    })
  }

  getVisibleFlights = () => {
    const { flights, query } = this.state
    const normalizedQuery = query.trim().toLowerCase()

    if (!normalizedQuery) {
      return flights
    }

    return flights.filter((flight) => (
      flight.flight_num?.toString().toLowerCase().includes(normalizedQuery)
      || flight.dest_stn.toLowerCase().includes(normalizedQuery)
    ))
  }


  openExportModal = () => {
    this.setState({ exportModalVisible: true })
  }

  closeExportModal = () => {
    this.setState({ exportModalVisible: false })
  }

  handleExportTypeChange = (event) => {
    this.setState({ exportType: event.target.value })
  }

  handleExportDateChange = (date) => {
    this.setState({ exportDate: date ? moment(date) : null })
  }

  fetchFlightsByDate = (date) => {
    const headers = { station: this.state.station }
    return Http.get('/scrub_flight_list', {
      params: { date },
      headers,
    }).then(({ data }) => data?.data || [])
  }

  getWeeklyDates = (selectedDate) => {
    const weekStart = moment(selectedDate).startOf('isoWeek')
    return Array.from({ length: 7 }, (_, idx) => (
      moment(weekStart).add(idx, 'days').format('YYYY-MM-DD')
    ))
  }

  exportToExcel = async (flightsToExport, fileDateLabel, reportType) => {
    const { station } = this.state
    const workbook = new ExcelJS.Workbook()
    const worksheet = workbook.addWorksheet('Flight_Details')
    const worksheet2 = workbook.addWorksheet('AWB_Details')

    const columnKeys = [
      'Title',
      'Flt_Dt',
      'dep_tm_et',
      'Orig_Stn_Cd',
      'Dest_Stn_Cd',
      'Flt_Summary',
      'Max_PMC',
      'Max_PAG',
      'Max_LD2',
      'Max_LD3',
      'Max_LD4',
      'Plan_PMC',
      'Plan_PAG',
      'Plan_LD2',
      'Plan_LD3',
      'Plan_LD4',
      'Final_PMC',
      'Final_PAG',
      'Final_LD2',
      'Final_LD3',
      'Final_LD4',
      'Total_AWBs',
      'Compliant_AWBs',
      'Not_Compliant_AWBs',
      'Scrub_Copy_Submitted',
      'pct_compliance',
      'ID',
      'scrub_desk_name',
      'sortable_dep_tm',
      'built_awbs',
      'not_tendered_awbs',
      'not_arrived_awbs',
      'block_awbs',
      'no_space_awbs',
      'no_time_to_build_awbs',
      'utl_awbs',
      'not_ready_awbs',
      'mef_awbs',
      'departed_awbs',
      'no_docs_awbs',
      'partial_build_awbs',
      'uld_availability_awbs',
    ]
    const awbColumnKeys = [
      'Title',
      'flt_title',
      'Item_Num',
      'AWB_ULD_Nb',
      'piece_type',
      'plan_type',
      'location',
      'location_type',
      'days_delayed',
      'priority',
      'product',
      'scrub_YN',
      'scrub_built_ulds',
      'built_status',
      'mef_added_by_scrub',
      'orig_stn_cd',
      'dest_stn_cd',
      'flt_nb',
      'flt_dt',
    ]

    worksheet.columns = columnKeys.map((key) => ({
      header: key,
      key,
      width: 20
    }))
    worksheet2.columns = awbColumnKeys.map((key) => ({
      header: key,
      key,
      width: 20
    }))

    worksheet.getRow(1).font = {
      bold: true,
      size: 12,
      color: { argb: 'FFFFFFFF' }
    }
    worksheet2.getRow(1).font = {
      bold: true,
      size: 12,
      color: { argb: 'FFFFFFFF' }
    }
    worksheet.getRow(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      // #307ca9
      fgColor: { argb: 'FF307ca9' }
    }
    worksheet2.getRow(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      // #307ca9
      fgColor: { argb: 'FF307ca9' }
    }
    let awbRowCounter = 2
    flightsToExport.forEach((flight, index) => {
      let compliant_awbs = 0
      let not_compliant_awbs = 0
      let built_awbs = 0
      let not_tendered_awbs = 0
      let not_arrived_awbs = 0
      let block_awbs = 0
      let no_space_awbs = 0
      let no_time_to_build_awbs = 0
      let utl_awbs = 0
      let not_ready_awbs = 0
      let mef_awbs = 0
      let departed_awbs = 0
      let no_docs_awbs = 0
      let partial_build_awbs = 0
      let uld_availability_awbs = 0
      flight?.scrub_data && flight?.scrub_data?.workareaData && Object.keys(flight?.scrub_data?.workareaData).forEach(key => {
        const workarea = flight?.scrub_data?.workareaData?.[key]
        workarea?.loose?.forEach(awb => {
          if (['Built', 'Not Tendered', 'Still at Origin / Has not arrived', 'Hold / Block', 'No Space', 'MEF', 'Departed'].includes(awb?.comments)) {
            compliant_awbs++
          } else {
            not_compliant_awbs++
          }
          if (awb?.comments === 'Built') {
            built_awbs++
          }
          if (awb?.comments === 'Not Tendered') {
            not_tendered_awbs++
          }
          if (awb?.comments === 'Still at Origin / Has not arrived') {
            not_arrived_awbs++
          }
          if (awb?.comments === 'Hold / Block') {
            block_awbs++
          }
          if (awb?.comments === 'No Space') {
            no_space_awbs++
          }
          if (awb?.comments === 'No Time to Build') {
            no_time_to_build_awbs++
          }
          if (awb?.comments === 'UTL') {
            utl_awbs++
          }
          if (awb?.comments === 'Not Ready for Carriage') {
            not_ready_awbs++
          }
          if (awb?.comments === 'MEF') {
            mef_awbs++
          }
          if (awb?.comments === 'Departed') {
            departed_awbs++
          }
          if (awb?.comments === 'No Documents') {
            no_docs_awbs++
          }
          if (awb?.comments === 'Partial Build') {
            partial_build_awbs++
          }
          if (awb?.comments === 'ULD Availability') {
            uld_availability_awbs++
          }
        })
      })
      // const binConfig = get_bin_config(flight)
      const scubData = getScrubData(flight, this.state.priorityData)
      let total_awbs = 0
      let item_num = 1
      scubData?.workarea && scubData?.workarea.forEach(key => {
        const workarea = scubData?.workareaData?.[key]
        total_awbs += workarea?.loose?.length || 0
        workarea?.loose?.forEach((awb) => {
          const awbRow = {
            Title: `${flight.org_stn}${flight.dest_stn}_${flight.flight_num}_${moment(flight.dept_date).format('M/D/YYYY')}_${awb.awb_no}`,
            flt_title: `${flight.org_stn}${flight.dest_stn}_${flight.flight_num}_${moment(flight.dept_date).format('M/D/YYYY')}`,
            Item_Num: item_num++,
            AWB_ULD_Nb: (awb.awb_no || '') + (awb?.piece_type == 'partial' ? '*' : ''),
            piece_type: awb.piece_type || 'loose',
            plan_type: 'booked',
            location: awb.location || '',
            location_type: key != 'UNKNOWN' ? key : '',
            days_delayed: awb.delay || '',
            priority: awb.pri || '',
            product: awb.prod_code || '',
            scrub_YN: awb.yesNo || 'No',
            scrub_built_ulds: awb.builtUlds || '',
            built_status: awb.comments || '',
            mef_added_by_scrub: '',
            orig_stn_cd: flight.org_stn || '',
            dest_stn_cd: flight.dest_stn || '',
            flt_nb: flight.flight_num || '',
            flt_dt: moment(flight.dept_date).format('M/D/YYYY') || '',
          }
          const awbRowInstance = worksheet2.addRow(awbRow)
          if (awbRowCounter % 2 === 0) {
            awbRowInstance.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFA1CFEA' }
            }
          }
          awbRowCounter++
        })
        workarea?.uld?.forEach((uld) => {
          const uldRow = {
            Title: `${flight.org_stn}${flight.dest_stn}_${flight.flight_num}_${moment(flight.dept_date).format('M/D/YYYY')}_${uld.awb_no}`,
            flt_title: `${flight.org_stn}${flight.dest_stn}_${flight.flight_num}_${moment(flight.dept_date).format('M/D/YYYY')}`,
            Item_Num: item_num++,
            AWB_ULD_Nb: uld.awb_no || '',
            piece_type: 'pre-built',
            plan_type: 'booked',
            location: uld.location || '',
            location_type: key != 'UNKNOWN' ? key : '',
            days_delayed: uld.delay || '',
            priority: uld.pri || '',
            product: uld.prod_code || '',
            scrub_YN: uld.yesNo || 'No',
            scrub_built_ulds: uld.builtUlds || '',
            built_status: uld.comments || '',
            mef_added_by_scrub: '',
            orig_stn_cd: flight.org_stn || '',
            dest_stn_cd: flight.dest_stn || '',
            flt_nb: flight.flight_num || '',
            flt_dt: moment(flight.dept_date).format('M/D/YYYY') || '',
          }
          const uldRowInstance = worksheet2.addRow(uldRow)
          if (awbRowCounter % 2 === 0) {
            uldRowInstance.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFA1CFEA' }
            }
          }
          awbRowCounter++
        })
      })
      scubData.summaryRows.forEach((awb) => {
        if (awb.awb_no == '') return
        const mefRow = {
          Title: `${flight.org_stn}${flight.dest_stn}_${flight.flight_num}_${moment(flight.dept_date).format('M/D/YYYY')}_${awb.awb_no || ''}`,
          flt_title: `${flight.org_stn}${flight.dest_stn}_${flight.flight_num}_${moment(flight.dept_date).format('M/D/YYYY')}`,
          Item_Num: item_num++,
          AWB_ULD_Nb: awb.awb_no || '',
          piece_type: 'loose',
          plan_type: 'MEF',
          location: awb.location || '',
          location_type: '',
          days_delayed: awb.delay || '',
          priority: awb.pri || '',
          product: awb.prod_code || '',
          scrub_YN: awb.yesNo || 'No',
          scrub_built_ulds: awb.builtUlds || '',
          built_status: awb.comments || '',
          mef_added_by_scrub: '',
          orig_stn_cd: flight.org_stn || '',
          dest_stn_cd: flight.dest_stn || '',
          flt_nb: flight.flight_num || '',
          flt_dt: moment(flight.dept_date).format('M/D/YYYY') || '',
        }
        const mefRowInstance = worksheet2.addRow(mefRow)
        if (awbRowCounter % 2 === 0) {
          mefRowInstance.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFA1CFEA' }
          }
        }
        awbRowCounter++
      })

      const rowData = {
        Title: `${flight.org_stn}${flight.dest_stn}_${flight.flight_num}_${moment(flight.dept_date).format('M/D/YYYY')}`,
        Flt_Dt: moment(flight.dept_date).format('M/D/YYYY'),
        dep_tm_et: moment.utc(flight.dept_date).tz(this.state.timezone).format('hh:mm A'),
        Orig_Stn_Cd: flight.org_stn,
        Dest_Stn_Cd: flight.dest_stn,
        Flt_Summary: flight.scrub_data?.summary || '',
        Max_PMC: scubData?.maxConfig?.PMC || '',
        Max_PAG: scubData?.maxConfig?.PAG || '',
        Max_LD2: scubData?.maxConfig?.LD2 || '',
        Max_LD3: scubData?.maxConfig?.LD3 || '',
        Max_LD4: scubData?.maxConfig?.LD48FQA || '',
        Plan_PMC: scubData?.plannedConfig?.PMC || '',
        Plan_PAG: scubData?.plannedConfig?.PAG || '',
        Plan_LD2: scubData?.plannedConfig?.LD2 || '',
        Plan_LD3: scubData?.plannedConfig?.LD3 || '',
        Plan_LD4: scubData?.plannedConfig?.LD48FQA || '',
        Final_PMC: scubData?.finalConfig?.PMC || '',
        Final_PAG: scubData?.finalConfig?.PAG || '',
        Final_LD2: scubData?.finalConfig?.LD2 || '',
        Final_LD3: scubData?.finalConfig?.LD3 || '',
        Final_LD4: scubData?.finalConfig?.LD48FQA || '',
        Total_AWBs: total_awbs,
        Compliant_AWBs: compliant_awbs,
        Not_Compliant_AWBs: not_compliant_awbs,
        Scrub_Copy_Submitted: flight.scrub_data && flight.scrub_data?.completion == 100 ? 'Yes' : 'No',
        pct_compliance: total_awbs > 0 ? (compliant_awbs / total_awbs) : 0,
        ID: flight.id,
        scrub_desk_name: flight.scrub_data?.user?.name || '',
        sortable_dep_tm: moment(flight.dept_date).tz(this.state.timezone).format('HH:mm'),
        built_awbs: built_awbs,
        not_tendered_awbs: not_tendered_awbs,
        not_arrived_awbs: not_arrived_awbs,
        block_awbs: block_awbs,
        no_space_awbs: no_space_awbs,
        no_time_to_build_awbs: no_time_to_build_awbs,
        utl_awbs: utl_awbs,
        not_ready_awbs: not_ready_awbs,
        mef_awbs: mef_awbs,
        departed_awbs: departed_awbs,
        no_docs_awbs: no_docs_awbs,
        partial_build_awbs: partial_build_awbs,
        uld_availability_awbs: uld_availability_awbs
      }
      const row = worksheet.addRow(rowData)
      if (index % 2 === 0) {
        row.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFA1CFEA' }
        }
      }
    })

    try {
      const buffer = await workbook.xlsx.writeBuffer()
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      saveAs(blob, `Scrub_Copy_${station}_${reportType}_${fileDateLabel}.xlsx`)
    } catch (error) {
      console.error('Failed to export scrub copy excel file', error)
    }
  }

  confirmExport = async () => {
    const { exportDate, exportType } = this.state
    if (!exportDate) {
      return
    }

    this.setState({ exportLoading: true })

    try {
      if (exportType === 'week') {
        const weeklyDates = this.getWeeklyDates(exportDate)
        const weeklyFlights = await Promise.all(weeklyDates.map((date) => this.fetchFlightsByDate(date)))
        await this.exportToExcel(weeklyFlights.flat(), `${weeklyDates[0]}_to_${weeklyDates[6]}`, 'week')
      } else {
        const selectedDate = moment(exportDate).format('YYYY-MM-DD')
        const flights = await this.fetchFlightsByDate(selectedDate)
        await this.exportToExcel(flights, selectedDate, 'day')
      }
      this.setState({ exportModalVisible: false })
    } catch (error) {
      console.error('Failed to prepare scrub copy export', error)
    } finally {
      this.setState({ exportLoading: false })
    }
  }

  renderExportModal = () => {
    const { exportModalVisible, exportType, exportDate, exportLoading } = this.state

    return (
      <Modal
        title='Export Scrub Copy Report'
        open={exportModalVisible}
        onCancel={this.closeExportModal}
        onOk={this.confirmExport}
        okText='Generate'
        confirmLoading={exportLoading}
        okButtonProps={{
          disabled: !exportDate,
          className: 'custom-button'
        }}
        cancelButtonProps={{ className: 'custom-button' }}
        className='custom-modal export-scrub-modal'
      >
        <div className='mb-3'>
          <label className='custom-label'>Report Type</label>
          <Radio.Group onChange={this.handleExportTypeChange} value={exportType}>
            <Radio value='day'>Day</Radio>
            <Radio value='week'>Week</Radio>
          </Radio.Group>
        </div>
        <div>
          <label className='custom-label'>{exportType === 'week' ? 'Select Week' : 'Select Date'}</label>
          <DatePicker
            className='scm-date'
            allowClear={false}
            value={exportDate}
            picker={exportType === 'week' ? 'week' : 'date'}
            suffixIcon={<CalendarOutlined />}
            onChange={this.handleExportDateChange}
          />
        </div>
      </Modal>
    )
  }

  renderHeader = () => {
    const { date, flights } = this.state
    const compliance = flights => ((flights.reduce((acc, flight) => acc + (flight.scrub_data?.compliance == 100 ? 1 : 0), 0) / flights.length) * 100 || 0)
    const completion = flights => ((flights.reduce((acc, flight) => acc + (flight.scrub_data?.completion == 100 ? 1 : 0), 0) / flights.length) * 100 || 0)

    return (
      <>
        <Row gutter={[8, 8]} align='middle'>
          <Col xs={24} lg={24}>
            <div className='f-spacebtw'>
              <Space direction='horizontal' size={16} className='scm-header-space'>
                <Title level={5} className='mb-0'>{this.state.station} Scrub Copy Manager</Title>
                <Tooltip title='Refresh'>
                  <Button type='ghost' className='image-btn scm-refresh-btn' onClick={this.handleRefresh}>
                    <ReloadOutlined />
                  </Button>
                </Tooltip>
              </Space>
              <Button type='primary' className='custom-button' onClick={this.openExportModal}>Export to Excel</Button>
            </div>
          </Col>
          <Col xs={24} lg={24}>
            <Row gutter={[16, 16]} align='bottom' className='scm-search-row'>
              <Col flex='auto'>
                <Row gutter={[16, 16]} align='middle' className='scm-date-row'>
                  <Col flex='0 1 180px'>
                    <div>
                      <label className='custom-label' htmlFor='from_date'>Flight Date</label>
                      <DatePicker
                        className='scm-date'
                        allowClear={false}
                        value={date ? moment(date) : null}
                        placeholder='Select Date'
                        suffixIcon={<CalendarOutlined />}
                        onChange={this.handleDateChange}
                      />
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col xs className='scm-stats-col'>
                <div className='scm-stats'>
                  <div><span>% Completion:</span><strong className={getComplianceClass(completion(flights))}>{`${this.formatDecimal(completion(flights))}%`}</strong></div>
                  <div><span>% Compliance:</span><strong className={getComplianceClass(compliance(flights))}>{`${this.formatDecimal(compliance(flights))}%`}</strong></div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </>
    )
  }

  renderBody = () => {
    const flights = this.getVisibleFlights()
    const columns = [
      {
        title: 'Departure Date/Time (local)',
        dataIndex: 'dept_date',
        key: 'departure',
        align: 'left',
        render: (_, flight) => {
          const departure = flight.latest_dept_date ? moment.utc(flight.latest_dept_date).tz(this.state.timezone).format('DDMMMYY h:mm A') : moment.utc(flight.dept_date).tz(this.state.timezone).format('DDMMMYY h:mm A')
          return <span>{departure.toUpperCase()}</span>
        }
      },
      {
        title: 'Flight #',
        dataIndex: 'flight_num',
        key: 'flight_num',
        width: '12%'
      },
      {
        title: 'City Pair',
        key: 'city_pair',
        render: (_, flight) => `${flight.org_stn} - ${flight.dest_stn}`
      },
      {
        title: '% Compliance',
        key: 'compliance',
        align: 'center',
        render: (_, flight) => {
          if(flight?.scrub_data?.workareaData) {
            let looseCount = 0
            Object.keys(flight?.scrub_data?.workareaData).forEach(key => {
              const workarea = flight?.scrub_data?.workareaData?.[key]
              if(workarea?.loose?.length > 0) {
                looseCount ++
              }
            })
            if(looseCount === 0) {
              return <span className='scm-compliance-low'>N/A</span>
            }
          }
          const compliance = flight?.scrub_data?.compliance || 0
          return <span className={getComplianceClass(compliance)}>{`${this.formatDecimal(compliance)}%`}</span>
        }
      }
    ]

    return (
      <div className='scm-table-wrap'>
        <div className='table-outer scm-table-wrap'>
          <Table
            className='custom-table scm-table selected-row-table'
            dataSource={flights}
            columns={columns}
            pagination={false}
            rowKey={(record) => record.id || record.key}
            rowSelection={{
              type: 'radio',
              selectedRowKeys: this.state.selectedRowKeys,
              onSelect: (record) => {
                this.handleSelectScrubCopy(record)
              },
            }}
            onRow={(record) => ({ onClick: () => this.handleSelectScrubCopy(record) })}
          />
        </div>
      </div>
    )
  }
  editScrubCopy = (open, record = {}) => {
    this.setState({
      modalVisible: open,
      data: record,
    })
  }

  renderScrubCopy = () => (
    <ScrubCopy
      closeModal={() => this.editScrubCopy(false)}
      data={this.state.data}
      priorityData={this.state.priorityData}
    />
  )

  render() {
    return (
      <div className='position-relative'>
        {this.renderExportModal()}
        <div className='scrub-header-search'>
          <Search allowClear className='search-input' placeholder='Search Flight or Destination'
            onChange={this.handleSearch} value={this.state.query}
          />
        </div>
        <Row gutter={[16, 16]}>
          <Col xs={24} xl={10} xxl={9}>
            <Card className='custom-card h-100'>
              <Row gutter={[16, 16]}>
                <Col xs={24}>
                  {this.renderHeader()}
                </Col>
                <Col xs={24}>
                  {this.renderBody()}
                </Col>
              </Row>
            </Card>
          </Col>
          {
            this.state.isModalView ?
              <Modal
                title='Scrub Copy'
                open={this.state.modalVisible}
                onCancel={() => this.editScrubCopy(false)}
                className='custom-modal scrub-copy-modal'
                destroyOnClose={false}
                footer={null}
                width={1400}
                centered
              >
                {this.renderScrubCopy()}
              </Modal>
              :
              <Col xs={0} xl={14} xxl={15}>
                <Card className='custom-card scrub-copy-card h-100' >
                  <Title level={5}>Scrub Copy</Title>
                  {this.renderScrubCopy()}
                </Card>

              </Col>
          }
          <Col xs={24} lg={24}>
            <Button type='default' className='custom-button scm-refresh-btn min-width-110' onClick={() => window.history.back()}>
              Back
            </Button>
          </Col>
        </Row>
      </div>
    )
  }
}

export default ScrubCopyManager